import { render, staticRenderFns } from "./TradingCard.vue?vue&type=template&id=4cd5a2a5&scoped=true"
import script from "./TradingCard.vue?vue&type=script&lang=js"
export * from "./TradingCard.vue?vue&type=script&lang=js"
import style0 from "./TradingCard.vue?vue&type=style&index=0&id=4cd5a2a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd5a2a5",
  null
  
)

export default component.exports